import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

const Home = lazy(() => import("./pages/home/index.jsx"));
const Editor = lazy(() => import("./pages/editor/index.jsx"));
const NeedEditor = lazy(() => import("./pages/needEdit/index.jsx"));
const Login = lazy(() => import("./pages/login/index.jsx"));
/**
 React.lazy 目前只支持默认导出（default exports）。
 如果你想被引入的模块使用命名导出（named exports），
 你可以创建一个中间模块，来重新导出为默认模块。
 这能保证 tree shaking 不会出错，并且不必引入不需要的组件。
 */
const App = () => {
  return (
    <Router>
      <Suspense
        fallback={
          <div
            style={{
              color: "#717171",
              height: "100vh",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Loading...
          </div>
        }
      >
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/editor/:book_id" component={Editor} />
          <Route
            exact
            path="/noanalysis/:user_id/:book_id"
            component={NeedEditor}
          />
          <Route exact path="/login" component={Login} />
        </Switch>
      </Suspense>
    </Router>
  );
};
export default App;
